/* eslint-disable camelcase */

/**
 * Password policy data interface.
 * @interface SecuritySettingsData
 */
export interface SecuritySettingsData {
  enable_min_password_length: boolean;
  minimum_password_length: number;
  require_digit_in_password: boolean;
  require_uppercase_in_password: boolean;
  require_lowercase_in_password: boolean;
  enable_disallowed_characters_in_password: boolean;
  disallowed_characters_in_password: string;
  enable_2fa: boolean;
  enforce_2fa_globally: boolean;
}

/**
 * Default security settings values.
 * @type {SecuritySettingsData}
 */
export const DEFAULT_SECURITY_SETTINGS: SecuritySettingsData = {
  enable_min_password_length: true,
  minimum_password_length: 8,
  require_digit_in_password: false,
  require_uppercase_in_password: false,
  require_lowercase_in_password: false,
  enable_disallowed_characters_in_password: false,
  disallowed_characters_in_password: "",
  enable_2fa: false,
  enforce_2fa_globally: false,
};
